import { memo, useMemo } from 'react';

import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Flag from '@atlaskit/flag';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

import { toggleSettingsDialog } from 'src/redux/diff-settings';
import { ComponentFlagProps } from 'src/redux/flags/types';
import messages from 'src/sections/repository/sections/pull-request/components/diff-settings/i18n';

import { AppearanceTypes } from './simple/simple-flag';

export const DiffSettingsErrorFlag = memo((props: ComponentFlagProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { id, handleDismissed } = props;

  const actions = useMemo(
    () => [
      {
        content: intl.formatMessage(messages.errorFlagRetryButton),
        onClick: () => {
          dispatch(toggleSettingsDialog(true));
          handleDismissed(id);
        },
      },
    ],
    [dispatch, id, intl, handleDismissed]
  );

  return (
    <Flag
      actions={actions}
      appearance={AppearanceTypes.normal}
      description={intl.formatMessage(messages.errorFlagDescription)}
      icon={
        <StatusWarningIcon
          spacing="spacious"
          label=""
          color={token('color.icon.warning')}
        />
      }
      title={intl.formatMessage(messages.errorFlagTitle)}
      {...props}
    />
  );
});
